import { createContext } from "react";
import type { RadioGroupState } from "react-stately";

type RadioGroupContextType = RadioGroupState | null;
export const RadioGroupContext = createContext<RadioGroupContextType>(null);
